import { useEffect } from "react";

export function useOneTrustAccessibility() {
  useEffect(() => {
    let activeModal: HTMLElement | null = null;

    const updateState = () => {
      const modal = getVisibleModal();

      if (modal && !activeModal) {
        activeModal = modal;

        trapFocus(modal);
        makeAppInert(true);

        attachCloseListeners();
      }

      if (!modal && activeModal) {
        makeAppInert(false);
        activeModal = null;
      }
    };

    const observer = new MutationObserver(() => {
      updateState();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    updateState();

    return () => observer.disconnect();
  }, []);
}

function attachCloseListeners() {
  const selectors = [
    "#onetrust-accept-btn-handler",
    "#onetrust-reject-all-handler",
    ".ot-pc-refuse-all-handler",
    ".save-preference-btn-handler",
    ".onetrust-close-btn-handler"
  ];

  selectors.forEach((selector) => {
    document.querySelectorAll(selector).forEach(btn => {
      btn.addEventListener("click", () => {
        makeAppInert(false);
      })
    });
  });
}

function getVisibleModal(): HTMLElement | null {
  const containers = [
    document.querySelector("#onetrust-banner-sdk"),
    document.querySelector("#onetrust-pc-sdk")
  ];

  for (const container of containers) {
    if (!container) continue;

    const style = window.getComputedStyle(container);

    const visible =
      style.display !== "none" &&
      style.visibility !== "hidden" &&
      container.getBoundingClientRect().height > 0;

    if (visible) {
      return container.querySelector("[role='dialog']") as HTMLElement;
    }
  }

  return null;
}

function trapFocus(modal: HTMLElement) {
  if ((modal as any).__focusTrapInstalled) return;

  (modal as any).__focusTrapInstalled = true;

  const focusable = modal.querySelectorAll<HTMLElement>(
    "a[href], button, textarea, input, select, [tabindex]:not([tabindex='-1'])"
  );

  if (!focusable.length) return;

  const first = focusable[0];
  const last = focusable[focusable.length - 1];

  setTimeout(() => first.focus(), 0);

  modal.addEventListener("keydown", (e) => {
    if (e.key !== "Tab") return;

    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });
}

function makeAppInert(isInert: boolean) {
  const root = document.getElementById("root");
  if (!root) return;

  if (isInert) {
    root.setAttribute("aria-hidden", "true");
    root.setAttribute("inert", "");
  } else {
    root.removeAttribute("aria-hidden");
    root.removeAttribute("inert");
  }
}